import { LESSON } from "../Helpers/Enums";

export default class LessonContentModel {
  constructor(
    contentTypeId,
    actionButton,
    editorText,
    quote,
    videoContent,
    interactiveContent,
    quiz,
    sortingGame,
  ) {
    this.lessonContentId = 0;
    this.contentTypeId = contentTypeId ?? LESSON.CONTENT_TYPE.PARAGRAPH;
    this.contentOrder = 0;
    this.actionButton = actionButton;
    this.editorText = editorText;
    this.quote = quote;
    this.videoContent = videoContent;
    this.interactiveContent = interactiveContent;
    this.quiz = quiz;
    this.contentValid = false;
    this.expand = true;
    this.isChanged = true;
    this.sortingGame = sortingGame;
  }

  static convertToJSObject(lessonContent) {
    return JSON.parse(JSON.stringify(lessonContent));
  }
}
